<template>
  <div class="rank" v-if="dataList != null">
    <template v-if="!giftingEnabled">
      <UiEmpty></UiEmpty>
    </template>
    <template v-else>
      <div class="rank-left">
        <div class="notice" @click="handleClickshowRen"></div>
        <div class="rank-box">
          <div class="title-box panel-head">
            <div class="title">
              <div class="item title1">
                <div class="label-box">
                  <span class="label-shadow">排名</span>
                  <span class="label-text">排名</span>
                </div>
              </div>
              <div class="item title2">
                <div class="label-box">
                  <span class="label-shadow">战队名称</span>
                  <span class="label-text">战队名称</span>
                </div>
              </div>
              <div class="item title3">
                <div class="label-box">
                  <span class="label-shadow">人气值</span>
                  <span class="label-text">人气值</span>
                </div>
              </div>
            </div>
          </div>

          <div class="list-box">
            <div class="list" v-if="dataList && dataList.clanRank">
              <div v-for="(item, index) in dataList.clanRank"
                :class="{ 'list-item': true, selected: index === activeIndex }" :key="index"
                @click="toggleActive(index)">
                <div class="first">
                  <div class="label-box">
                    <span class="label-shadow">{{ index + 1 }}</span>
                    <span class="label-text">{{ index + 1 }}</span>
                  </div>
                </div>
                <div class="avatar" :style="{ 'background-image': `url(${item?.avatar})` }">
                </div>
                <div class="name">
                  <div class="label-box">
                    <span class="label-shadow">{{ item?.name }}</span>
                    <span class="label-text">{{ item?.name }}</span>
                  </div>
                </div>
                <div class="hot">
                  <div class="label-box">
                    <span class="label-shadow">{{ countShow(item?.popularity) }}</span>
                    <span class="label-text">{{ countShow(item?.popularity) }}</span>
                  </div>
                </div>
                <UiButton class="rank-gift" hook @click="goGift(item)">
                  <div class="label-box">
                    <span class="label-shadow">送礼</span>
                    <span class="label-text">送礼</span>
                  </div>
                </UiButton>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="rank-right">
        <FanTopThree :items="fanListTop3" size="sm" :default-avatar="defaultUrl" show-prefix />
        <FanList
          :items="filteredList"
          :default-avatar="defaultUrl"
          :user-info="dataList.personalGifts"
          :user-img-url="useImgUrl"
          bg-type="solid"
        />
      </div>
    </template>
  </div>
</template>

<script setup>
// 页签名 popularity(与 UI/URL 一致), 实际数据维度: 战队人气值累积排行
import { computed, inject, ref } from 'vue'
import * as api from '@/service/index'
import { useAppStore, useStageStore } from '@/store'
import FanTopThree from '../fan-top-three.vue'
import FanList from '../fan-list.vue'
import UiEmpty from '@/components/ui-empty'
import UiButton from '@/components/ui-button.vue'

const props = defineProps({
  dataList: Object,
  activeIndex: Number
})

const getTeamRankingsList = inject('getTeamRankingsList')

const appStore = useAppStore()
const stageStore = useStageStore()

const defaultUrl = ref('https://website.xdcdn.net/form/match/avatar2024/Portrait1.png')
const useImgUrl = ref('')

const token = computed(() => appStore.token)
const giftingEnabled = computed(() => stageStore.giftingEnabled)

const fanListTop3 = computed(() => {
  return props.dataList.personal?.filter((item, index) => index <= 2)
})
const filteredList = computed(() => {
  return props.dataList.personal?.filter((item, index) => index > 2)
})

function toggleActive(index) {
  if (props.activeIndex === index) {
    return
  }
  getTeamRankingsList(index)
}

function getPathUrlImg() {
  const storedAvatar = localStorage.getItem('DCavatar')
  const storedTaptapAvatar = localStorage.getItem('DCtaptapavatar')
  if (storedTaptapAvatar) {
    useImgUrl.value = storedTaptapAvatar
  } else if (storedAvatar) {
    useImgUrl.value = `https://website.xdcdn.net/form/match/avatar2024/${storedAvatar}.png`
  } else {
    useImgUrl.value = defaultUrl.value
  }
}

function handleClickshowRen() {
  appStore.openModal({ id: 'popularity-rewards' })
}

async function goGift(item) {
  if (!token.value) return
  let data = {
    token: token.value,
    force: false
  }
  try {
    appStore.openModal({
      id: 'present',
      params: { team: '', presentList: '' }
    })
    appStore.reqUserInfo(true)
    const res = await fetchGetGiftList(data)
    if (res.length) {
      appStore.openModal({
        id: 'present',
        params: { team: item, presentList: res }
      })
    }
  } catch (err) {
    console.log(err)
  }
}

async function fetchGetGiftList(data) {
  try {
    const req = await api.reqGiftList(data)
    if (req.status === 200) {
      return req.data
    }
  } catch (err) {
    console.log(err)
  }
}

function countShow(hot) {
  if (hot) {
    if (hot < 10000) {
      return hot
    } else if (10000 <= hot && hot < 99999999) {
      return (((hot / 10000) * 100) / 100).toFixed(2) + '万'
    } else {
      return 9999 + '万+'
    }
  } else {
    return 0
  }
}

// created
if (token.value) {
  fetchGetGiftList({ token: token.value, force: true })
  getPathUrlImg()
}
</script>

<style lang="scss" scoped>
@import "./index";
</style>
